<div fxLayout="column">
    <ppw-toolbar [menuTitle]="pageTitle" [showMenu]="true" [singleButton]="true" class="sticky-header">
        <div class="ppw-speed-dial-position">
            <button
                mat-mini-fab
                class="speed-dial-button"
                [ngClass]="{ 'btn-project': selectedTimesheetProject }"
                (click)="archive()"
                *ngIf="selectedClient"
                [matTooltip]="selectedTimesheetProject ? 'Archive project' : 'Archive client'">
                <mat-icon>remove_circle</mat-icon>
            </button>
            <button
                mat-mini-fab
                class="speed-dial-button"
                [ngClass]="{ 'btn-project': selectedTimesheetProject }"
                (click)="edit()"
                *ngIf="selectedClient"
                [matTooltip]="selectedTimesheetProject ? 'Edit project' : 'Edit client'">
                <mat-icon>edit</mat-icon>
            </button>
            <button
                mat-mini-fab
                class="speed-dial-button btn-project"
                (click)="newProject()"
                matTooltip="Create project">
                <mat-icon>stars</mat-icon>
            </button>
            <button mat-mini-fab class="speed-dial-button" (click)="createClient()" matTooltip="Create client">
                <mat-icon>filter_none</mat-icon>
            </button>
        </div>
    </ppw-toolbar>
    <table mat-table multiTemplateDataRows [dataSource]="datasource$" class="mat-elevation-z8 ppw-list" fxFill>
        <ng-container matColumnDef="name">
            <th class="mat-table-sticky-64" mat-header-cell *matHeaderCellDef>Client / ProjectName</th>
            <td mat-cell *matCellDef="let element">
                <div fxLayoutAlign="start center" [class.ident]="isTimesheetProject(undefined, element)">
                    <mat-icon *ngIf="isClient(undefined, element)">
                        {{ element.isExpanded ? 'expand_more' : 'chevron_right' }}
                    </mat-icon>
                    <mat-icon class="golden-star" *ngIf="isTimesheetProject(undefined, element)"> stars </mat-icon>
                    {{ element.name }}
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="icons">
            <th class="mat-table-sticky-64" mat-header-cell *matHeaderCellDef>Icons</th>
            <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="isTimesheetProject(undefined, element)">
                    <mat-icon
                        [matTooltip]="element.toInvoice ? 'Invoice' : 'do NOT invoice'"
                        class="material-icons"
                        [color]="element.toInvoice ? 'accent' : 'warn'"
                        >{{ element.toInvoice ? 'done' : 'not_interested' }}</mat-icon
                    >
                    <mat-icon
                        [matTooltip]="element.sendToCustomer ? 'Send' : 'Do NOT send'"
                        class="material-icons"
                        [color]="element.sendToCustomer ? 'accent' : 'warn'"
                        >{{ element.sendToCustomer ? 'send' : 'do_not_disturb_on' }}</mat-icon
                    >
                    <mat-icon
                        [matTooltip]="element.detailedTimesheet ? 'Detailed timesheet' : 'Simple timesheet'"
                        class="material-icons"
                        >{{ element.detailedTimesheet ? 'format_line_spacing' : 'menu' }}</mat-icon
                    >
                    <mat-icon
                        [matTooltip]="element.showPriority ? 'Show priority' : 'Do NOT show priority'"
                        class="material-icons"
                        >{{ element.showPriority ? 'notifications' : 'notifications_off' }}
                    </mat-icon>
                </ng-container>
            </td>
        </ng-container>

        <ng-container matColumnDef="issueKey">
            <th class="mat-table-sticky-64" mat-header-cell *matHeaderCellDef>issueKey</th>
            <td mat-cell *matCellDef="let element">
                {{ element.mapping?.issueKey }}
            </td>
        </ng-container>

        <ng-container matColumnDef="invoiceId">
            <th class="mat-table-sticky-64" mat-header-cell *matHeaderCellDef>invoiceId</th>
            <td mat-cell *matCellDef="let element">
                {{ element.mapping?.invoiceId }}
            </td>
        </ng-container>

        <ng-container matColumnDef="versionId">
            <th class="mat-table-sticky-64" mat-header-cell *matHeaderCellDef>versionId</th>
            <td mat-cell *matCellDef="let element">
                {{ element.mapping?.versionId }}
            </td>
        </ng-container>

        <ng-container matColumnDef="projectKey">
            <th class="mat-table-sticky-64" mat-header-cell *matHeaderCellDef>projectKey</th>
            <td mat-cell *matCellDef="let element">
                {{ element.mapping?.projectKey }}
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
            mat-row
            [class.ppw-list-highlight]="selectedClient === element"
            *matRowDef="let element; columns: displayedColumns; when: isClient"
            (click)="select(element)"
            (dblclick)="editClient(element)"></tr>
        <tr
            mat-row
            *matRowDef="let element; columns: displayedColumns; when: isTimesheetProject"
            [class.detail-row-highlight]="selectedTimesheetProject === element"
            (click)="selectTimesheetProject(element)"
            (dblclick)="editTimesheetProject(element)"
            class="detail-row"></tr>
    </table>
</div>
